module.exports = __webpack_public_path__ + "img/ch.c73d2d9d.svg";